import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../index';

export interface ModalState {
  open: boolean;
  anchor: string;
  modalActive: number;
}

const initialState: ModalState = {
  open: false,
  anchor: 'right',
  modalActive: 0,
};

export const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    setOpen: (state, action: PayloadAction<boolean>) => {
      state.open = action.payload;
    },
    setAnchor: (state, action: PayloadAction<string>) => {
      state.anchor = action.payload;
    },
    setModalActive: (state, action: PayloadAction<number>) => {
      state.modalActive = action.payload;
    },
    resetModal: (state) => {
      state.open = false;
      state.anchor = 'right';
      state.modalActive = 0;
    },
  },
});

export const { setOpen, setAnchor, setModalActive, resetModal } = modalSlice.actions;

export const selectModal = (state: RootState) => state.modal;

export default modalSlice.reducer;
